import React from 'react';
import RecurrenceManagementForm from "./RecurrenceManagementForm";
import StandardModal from "../../Modals/StandardModal";
import ActionButton from "../../Buttons/ActionButton";
import ModalToggleButton from "../../Inputs/ModalToggleButton";
import { objectIsNotEmpty } from "../../../Helpers/ObjectHelper";
import { useRecurrenceManagementForm } from "./RecurrenceManagementFormProvider";

const RecurrenceManagementToggleModal = () => {
    const {
        booking, recurrenceErrors, onConfirm, onRemove, recurrence, validCount, toBeRescheduledCount
    } = useRecurrenceManagementForm();

    const isConfirmDisabled = ()  => {
        if (!recurrence || !recurrence.hasOwnProperty('repeats')) { return true; }
        if (!recurrence.repeats || !recurrence.repeats.length) { return true; }
        if (!validCount || validCount < 1) { return true; }
        return false;
    }

    const getButtonClasses = () => {
        let classes = (booking.recurrence && booking.recurrence.repeats) ? ' primary' : ' secondary';
        if (objectIsNotEmpty(recurrenceErrors)) {
            classes += ' error';
        }
        return classes;
    }
    return (<>
        <ModalToggleButton
            title={(booking.recurrence?.repeats) ? "Edit Recurrence" : "Add Recurrence"}
            icon="fa-refresh"
            className={getButtonClasses()}
            isDisabled={!booking.start}
            modalContent={(isOpen, setClosed) =>

                <StandardModal
                    title="Recurrence"
                    open={isOpen}
                    onClose={setClosed}
                    isScrollable
                    showGradient
                    style={{
                        width: '41rem',
                    }}
                    buttons={[
                        <button
                            type="button"
                            className="button clear margin-bottom-0"
                            onClick={setClosed}
                        >
                            Cancel
                        </button>,
                        <ActionButton
                            title="Confirm"
                            className="button primary margin-bottom-0"
                            isDisabled={isConfirmDisabled()}
                            onClick={(evt) => {
                                onConfirm();
                                setClosed();
                            }}
                        />
                    ]}
                    secondaryButtons={[
                        <button
                            type="button"
                            className="button secondary margin-bottom-0"
                            onClick={() => {
                                onRemove();
                                setClosed();
                            }}
                        >
                            Remove Recurrence
                        </button>
                    ]}
                >
                    <RecurrenceManagementForm />
                </StandardModal>
            }
        />
    </>);
};

RecurrenceManagementToggleModal.propTypes = {};

RecurrenceManagementToggleModal.defaultProps = {};

export default RecurrenceManagementToggleModal;
